import ReportComponent from '../utils/ReportComponent/ReportComponent';

const defaultReportUtils = ReportComponent.utils;

const normalizeArray = (list = [], utils = defaultReportUtils) => {
    if (!Array.isArray(list) || !list.length) {
        return [];
    }

    const values = new Set(list.filter(Boolean));
    const normalized = [];

    utils.getKeysMetric().forEach((key) => {
        if (values.has(key)) {
            normalized.push(key);
        }
    });

    return normalized;
};

const isMetricEnabled = (value) => {
    if (value === undefined || value === null) {
        return false;
    }

    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'number') {
        return value !== 0;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) {
            return false;
        }

        return trimmed !== '0' && trimmed.toLowerCase() !== 'false';
    }

    return Boolean(value);
};

const normalizeObject = (value, utils = defaultReportUtils) => {
    if (!value || typeof value !== 'object') {
        return [];
    }

    return utils.getKeysMetric().filter((key) => isMetricEnabled(value[key]));
};

const extractMetricsFromValue = (value, utils = defaultReportUtils) => {
    if (!value) {
        return [];
    }

    if (Array.isArray(value) && value.length) {
        return normalizeArray(value, utils);
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
        return normalizeObject(value, utils);
    }

    if (typeof value === 'string' && value.length) {
        const trimmed = value.trim();
        if (!trimmed) {
            return [];
        }

        if (/^[01]+$/.test(trimmed)) {
            return normalizeArray(utils.getKeysMetric(trimmed), utils);
        }

        try {
            const parsed = JSON.parse(trimmed);
            return extractMetricsFromValue(parsed, utils);
        } catch (e) {
            const parsed = trimmed.split(',').map((item) => item.trim()).filter(Boolean);
            return normalizeArray(parsed, utils);
        }
    }

    return [];
};

const ensureGroupByFirst = (list = []) => {
    const filtered = (Array.isArray(list) ? list : []).filter((key) => key && key !== 'GroupBy');
    return ['GroupBy', ...filtered];
};

const resolveKeysFromParameters = (parameters = {}, utils = defaultReportUtils) => {
    const fromColumns = extractMetricsFromValue(parameters.columns, utils);
    if (fromColumns.length) {
        return ensureGroupByFirst(fromColumns);
    }

    const fromMetrics = extractMetricsFromValue(parameters.metrics, utils);
    if (fromMetrics.length) {
        return ensureGroupByFirst(fromMetrics);
    }

    return null;
};

export const resolveMetricsConfig = (parameters = {}, location = {}, reportMetricsValue = '', utils = defaultReportUtils) => {
    const parameterKeys = resolveKeysFromParameters(parameters, utils);
    if (parameterKeys && parameterKeys.length) {
        return {
            keys: parameterKeys,
            binary: utils.getStrMetric(parameterKeys)
        };
    }

    let metricsBinary = '';
    if (location?.query && location.query.metrics) {
        metricsBinary = location.query.metrics;
    } else if (typeof parameters.metricsBinary === 'string' && parameters.metricsBinary.length) {
        metricsBinary = parameters.metricsBinary;
    } else if (reportMetricsValue) {
        metricsBinary = reportMetricsValue;
    } else {
        metricsBinary = utils.getDefStrMetric();
    }

    const keys = ensureGroupByFirst(utils.getKeysMetric(metricsBinary));

    return {
        keys,
        binary: metricsBinary
    };
};

export default resolveMetricsConfig;
